<template>
  <div>
    <v-data-table
      :items="clientsRendered"
      :headers="headers"
      height="80vh"
      fixed-header
      :items-per-page="-1"
      :footer-props="{
      'page-text': 'Clients per page'
    }"
    >
      <template v-slot:item="props">
        <tr class="cursor" v-bind:class="{odd: props.index % 2, even: !props.index % 2}" @click="rowSelect(props.item)">
          <td style="text-align: center">{{props.item.client_id}}</td>
          <td style="text-align: center">{{props.item.client_name}}</td>
          <td style="text-align: center" class="pa-0"
              v-for="(dayWeek, index) in days"
              :key="index"
          >
            <div v-for="(hours, index) in props.item.tw_rendered[dayWeek]"
                 :key="index"
                 style="text-align: justify-all"
                 :class="{colorRed: (isInternalUser && hours.restricted), text: !(isInternalUser && hours.restricted)}"
            >
              {{hours.time_start}} - {{hours.time_end}}
            </div>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog v-model="showInfo" width="800px" transition="scale-transition">
      <ClientDisplayer
        v-if="clientInfo && isInternalUser"
        :client-info="clientInfo"
        v-on:toggle-info-displayer="toggleInfoDisplayer"
      ></ClientDisplayer>
    </v-dialog>

  </div>
</template>

<script>
  import ClientDisplayer from "./ClientDisplayer";
  import axios from 'axios'

  export default {
    name: "ClientsDataTable",
    components: {ClientDisplayer},
    props: {
      clientsClicked: Array,
      restricted: Boolean,
    },
    data() {
      return {
        showInfo: false,
        days: [
          'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'
        ],
        headers: [
          {
            text: 'Client ID',
            sortable: true,
            align: 'center',
            value: 'client_id',
            width: '5%'
          },
          {
            text: 'Client Name',
            sortable: true,
            align: 'center',
            value: 'client_name',
            width: '5%'

          },
          {
            text: 'Monday',
            sortable: true,
            align: 'center',
            value: 'tw_rendered.monday.time_start',
            width: '10%',
          },
          {
            text: 'Tuesday',
            sortable: false,
            align: 'center',
            value: 'tuesday',
            width: '10%',

          },
          {
            text: 'Wednesday',
            sortable: false,
            align: 'center',
            value: 'wednesday',
            width: '10%',

          },
          {
            text: 'Thursday',
            sortable: false,
            align: 'center',
            value: 'thursday',
            width: '10%',

          },
          {
            text: 'Friday',
            sortable: false,
            align: 'center',
            value: 'friday',
            width: '10%',

          },
          {
            text: 'Saturday',
            sortable: false,
            align: 'center',
            value: 'saturday',
            width: '10%',

          },
          {
            text: 'Sunday',
            sortable: false,
            align: 'center',
            value: 'sunday',
            width: '10%',
          },
        ],
        clientInfo: null,
      }
    },
    methods: {
      toggleInfoDisplayer() {
        this.showInfo = !this.showInfo;
        if (this.showInfo === false) {
          this.clientInfo = null;
        }
      },
      rowSelect(item) {
        axios.get(process.env.API_URL + '/clients/' + item.client_id)
          .then((response) => {
            this.toggleInfoDisplayer();
            this.clientInfo = response.data;
          })
      }
    },
    computed: {
      isInternalUser() {
        return this.$store.getters['auth/isInternalUser'];
      },
      clientsRendered() {
        this.clientsClicked.map((client) => {
            let tw_rendered = {
              Monday: [],
              Tuesday: [],
              Wednesday: [],
              Thursday: [],
              Friday: [],
              Saturday: [],
              Sunday: []
            };
            let filtered_tw = null;

            if (this.isInternalUser) {
              // Restricted Switch
              // TW Filtered by restricted or not

              filtered_tw = client.timewindows.filter((tw) => {
                return ((tw.restricted === this.restricted) || (tw.restricted === false))
              });
            } else {
              // For clients they can choose between used/not used tw

              filtered_tw = client.timewindows;
            }


            for (var i = 0; i < filtered_tw.length; i++) {
              tw_rendered[filtered_tw[i].day].push(filtered_tw[i]);
            }
            client['tw_rendered'] = tw_rendered;
            return client
          }
        );

        return this.clientsClicked


      },
    }
  }
</script>

<style scoped>

  .colorRed {
    color: red;
  }

</style>



// WEBPACK FOOTER //
// src/components/pages/Delivery/Zones/ClientsDataTable.vue